import React from 'react';
import PageTemplate from '../components/Common/PageTemplate';
import SiteSearch from '../components/Common/SiteSearch';

const SearchPage = () => {
  return (
    <PageTemplate title="Arama" subtitle="Haber, duyuru, sayfa ve kişi arayın">
      <div className="max-w-2xl mx-auto py-4">
        <SiteSearch
          placeholder="Haber, duyuru, sayfa, kişi ara…"
          autoFocus
        />
        <p className="text-center text-sm text-gray-400 mt-6">
          Aramak istediğiniz kelimeyi yazın, sonuçlar anında görünsün.
        </p>
      </div>
    </PageTemplate>
  );
};

export default SearchPage;
